import { delay, Observable, of } from 'rxjs';
import { fillArr } from '@hglobal/common';

import { GetGroupsRes } from '../models';

export function getGroupsMock(count = 12): Observable<GetGroupsRes> {
  return of({
    groups: fillArr(count, i => ({
      id: i,
      name: `Group ${i}`,
    })),
    itemsCount: count,
  }).pipe(delay(500));
}
